import api from 'api'
import {
  CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES,
  CACHE_TAG_CONFIGURED_SERVICES_LIST,
  CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST,
} from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getRentalFeesByConfiguredService: build.query({
      query: ({ id }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/rental`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES],
    }),
    addRentalFeesToConfiguredService: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/rental`,
        method: 'POST',
        body: { ...rest },
      }),
      invalidatesTags: [
        CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES,
        CACHE_TAG_CONFIGURED_SERVICES_LIST,
        CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST,
      ],
    }),
    updateRentalFeesConfiguredService: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/rental`,
        method: 'PUT',
        body: { ...rest },
      }),
      invalidatesTags: [
        CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES,
        CACHE_TAG_CONFIGURED_SERVICES_LIST,
        CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST,
      ],
    }),
    deleteRentalFeesFromConfiguredService: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/rental`,
        method: 'DELETE',
        body: { ...rest },
      }),
      invalidatesTags: [
        CACHE_TAG_CONFIGURED_SERVICE_RENTAL_FEES,
        CACHE_TAG_CONFIGURED_SERVICES_LIST,
        CACHE_TAG_RENTAL_FEE_TO_CS_VERSION_LIST,
      ],
    }),
    getRentalFeesResetHistory: build.query({
      query: ({ id }) => ({
        url: `/api/v1/core/configured-service/${id}/fee/rental/resets`,
        method: 'GET',
      }),
    }),
    getConfiguredServicesByRentalFee: build.query({
      query: ({ rentalFeeId, accountId }) => ({
        url: `/api/v1/core/configured-service/fee/${rentalFeeId}/${accountId}`,
        method: 'GET',
      }),
      providesTags: [CACHE_TAG_CONFIGURED_SERVICES_LIST],
    }),
  }),
})

export const {
  useLazyGetRentalFeesByConfiguredServiceQuery,
  useGetRentalFeesByConfiguredServiceQuery,
  useAddRentalFeesToConfiguredServiceMutation,
  useUpdateRentalFeesConfiguredServiceMutation,
  useDeleteRentalFeesFromConfiguredServiceMutation,
  useLazyGetRentalFeesResetHistoryQuery,
  useGetRentalFeesResetHistoryQuery,
  useLazyGetConfiguredServicesByRentalFeeQuery,
} = extendedApi
